export const Language = {
  supported: ['en', 'vi'],
};
